import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class ReferralService {
    Search = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject( filters )
        return await HttpClient.Get(`/api/referral?${queryString}`);
    }
    
    GetItems = async (country, depositNumber, pageSize, page) => {
        const queryString = utils.GetQueryStringsFromObject({
            pageSize, 
            page,
        })
        return await HttpClient.Get(`/api/referral/${country}/${depositNumber}/items?${queryString}`)
    }

    Get = async (referralId) => 
        await HttpClient.Get(`/api/referral/${referralId}`)

    GetVoucher = async (referralId) => 
        await HttpClient.Get(`/api/referral/${referralId}/voucher`);

    GetReferralDetails = async (referralId) => 
        await HttpClient.Get(`/api/referral/${referralId}/detail`);
}

export default new ReferralService();